"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VbzTabBar = void 0;
const react_1 = __importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const react_i18next_1 = require("react-i18next");
const className_1 = require("../../utils/className");
exports.VbzTabBar = (_a) => {
    var { id, list = [], dark = false, className = '' } = _a, props = __rest(_a, ["id", "list", "dark", "className"]);
    const [isDark, setIsDark] = react_1.useState('');
    const { t } = react_i18next_1.useTranslation();
    react_1.useEffect(() => {
        if (!dark) {
            return setIsDark('');
        }
        return setIsDark(' dark');
    }, [dark]);
    return (react_1.default.createElement(reactstrap_1.Nav, Object.assign({ id: id, tabs: true, className: className_1.mapToCssModules(['vbz-tabs', className, dark ? 'dark' : '']) }, props), list.map((item) => (react_1.default.createElement(reactstrap_1.NavItem, { key: item.key },
        react_1.default.createElement(reactstrap_1.NavLink, { id: item.id, key: item.key, href: item.href, active: item.active, className: `${className}${item.disabled ? ' disabled' : ''}`, onClick: item.onClick }, t(item.label ? item.label : '')))))));
};
//# sourceMappingURL=index.js.map